import { render, staticRenderFns } from "./SignUpCentral.vue?vue&type=template&id=cdc4cdf4"
import script from "./SignUpCentral.vue?vue&type=script&lang=js"
export * from "./SignUpCentral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports